import { CookiesStorage } from './CookieStorage';

interface IGlobal {
  [s: string]: any;
}

const storageAvailable = (type: string) => {
  const global: Window & IGlobal = window;

  try {
    const storage = global[type] as Storage;
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
};

export interface IStorageService {
  readonly length: number;

  clear(): void;

  getItem(key: string): string | null;

  key(index: number): string | null;

  removeItem(key: string): void;

  setItem(key: string, data: string): void;
}

enum StorageServiceType {
  LocalStorage = 'localStorage',
  CookieStorage = 'cookieStorage'
}

export default class StorageService implements IStorageService {
  private static APPLICATION_KEY = 'FF__';

  private storage: IStorageService;

  constructor() {
    if (!storageAvailable(StorageServiceType.LocalStorage)) {
      this.storage = new CookiesStorage();
    } else {
      this.storage = window.localStorage;
    }
  }

  public get length(): number {
    return this.storage.length;
  }

  public clear(): void {
    this.storage.clear();
  }

  public getItem(key: string): string | null {
    return this.storage.getItem(`${StorageService.APPLICATION_KEY}${key}`);
  }

  public key(index: number): string | null {
    return this.storage.key(index);
  }

  public removeItem(key: string): void {
    this.storage.removeItem(`${StorageService.APPLICATION_KEY}${key}`);
  }

  public setItem(key: string, data: string): void {
    if (this.keyExists(key)) {
      const stored = this.getItem(key);
      data = this.mergeSerialized(stored, data);
    }
    this.storage.setItem(`${StorageService.APPLICATION_KEY}${key}`, data);
  }

  protected keyExists(key: string): boolean {
    return !!this.storage.getItem(key);
  }

  private mergeSerialized(stored: string, updated: string) {
    const deserializedStored = JSON.parse(stored);
    const deserializedUpdated = JSON.parse(updated);
    return JSON.stringify({ ...deserializedStored, ...deserializedUpdated });
  }
}
